import React, { FC } from 'react'
import { getPriceWithSymbol } from '../../views'

import { InfoColumn } from '../info-column'
import { ItemLine } from '../item-line'
import { Row } from '../row'

import { useStyle } from './order-control-item-line.styles'
import { OrderControlItemLineProps } from './order-control-item-line.types'

export const OrderControlItemLine: FC<OrderControlItemLineProps> = ({
  className,
  productName,
  currency,
  imgUrl,
  quantity,
  deliveryPrice,
  items,
  noSuggestion,
  description,
  discount,
  days,
  totalOfferPrice,
  productDefaultPrice,
  isTooltip
}) => {
  const classes = useStyle()

  return (
    <ItemLine
      className={className}
      productName={productName}
      imgUrl={imgUrl}
      noSuggestion={noSuggestion}
      description={description}
      discount={discount}
      totalOfferPrice={totalOfferPrice}
      items={items}
      deliveryPrice={deliveryPrice}
      productDefaultPrice={productDefaultPrice}
      currency={currency}
      isTooltip={isTooltip}
    >
      <Row justifyContent="space-between" className={classes.infoColumns}>
        <InfoColumn
          title="Production Days:"
          titleTx="shopping.cart.production.days"
          value={String(days)}
        />
        <InfoColumn
          title="Item Quantity:"
          titleTx="shopping.cart.units.quantity"
          value={String(quantity)}
        />
        <InfoColumn
          title="Order Price:"
          titleTx="shopping.cart.order.price"
          value={getPriceWithSymbol(totalOfferPrice, currency)}
        />

        <InfoColumn
          title="Delivery Price:"
          titleTx="shopping.cart.item.delivery.price"
          value={getPriceWithSymbol(deliveryPrice, currency)}
        />
      </Row>
    </ItemLine>
  )
}
